/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const MappingStepMessages = defineMessages({
  title: {
    id: 'CatalogOpenApi.MappingStepMessages.title',
    defaultMessage: 'Review extension'
  },
  subtitle: {
    id: 'CatalogOpenApi.MappingStepMessages.subtitle',
    defaultMessage:
      'Displayed below are the mapped variables generated from the back-end system that will be available to use within an action.'
  },
  updateSubtitle: {
    id: 'CatalogOpenApi.MappingStepMessages.updateSubtitle',
    defaultMessage:
      'Click the button below to permanently replace the OpenAPI document for this extension.'
  },
  permanentlyReplaceOpenAPIspec: {
    id: 'CatalogOpenApi.MappingStepMessages.permanentlyReplaceOpenAPIspec',
    defaultMessage: 'Permanently replace OpenAPI document'
  },
  replace: {
    id: 'CatalogOpenApi.MappingStepMessages.replace',
    defaultMessage: 'Replace'
  },
  tableDescriptionReadOnly: {
    id: 'CatalogOpenApi.MappingStepMessages.tableDescriptionReadOnly',
    defaultMessage:
      'This table shows the operations defined in the OpenAPI document.'
  },
  tableDescriptionNotReadOnly: {
    id: 'CatalogOpenApi.MappingStepMessages.tableDescriptionNotReadOnly',
    defaultMessage:
      'Toggle which operations generated from the back-end system that will be available to use within an action.'
  },
  notificationTitle: {
    id: 'CatalogOpenApi.MappingStepMessages.notificationTitle',
    defaultMessage: '{invalidResponses} not supported.'
  },
  closeWarning: {
    id: 'CatalogOpenApi.MappingStepMessages.closeWarning',
    defaultMessage: 'Close warning'
  },
  request: {
    id: 'CatalogOpenApi.MappingStepMessages.request',
    defaultMessage: 'Request'
  },
  parameters: {
    id: 'CatalogOpenApi.MappingStepMessages.parameters',
    defaultMessage: 'Request parameters'
  },
  noParameters: {
    id: 'CatalogOpenApi.MappingStepMessages.noParameters',
    defaultMessage: 'The request has no parameters.'
  },
  response: {
    id: 'CatalogOpenApi.MappingStepMessages.response',
    defaultMessage: 'Response'
  },
  responseProperties: {
    id: 'CatalogOpenApi.MappingStepMessages.responseProperties',
    defaultMessage: 'Response properties'
  },
  noResponseProperties: {
    id: 'CatalogOpenApi.MappingStepMessages.noResponseProperties',
    defaultMessage: 'The response has no properties.'
  },
  dereferenceErrorTitle: {
    id: 'CatalogOpenApi.MappingStepMessages.dereferenceErrorTitle',
    defaultMessage:
      'Error while trying to parse Reference Objects in OpenAPI document.'
  },
  dereferenceErrorSubtitle: {
    id: 'CatalogOpenApi.MappingStepMessages.dereferenceErrorSubtitle',
    defaultMessage:
      'Delete your custom extension, remove from catalog, and try again.'
  },
  authenticationWarningTitle: {
    id: 'CatalogOpenApi.MappingStepMessages.authenticationWarningTitle',
    defaultMessage: 'Authentication re-configuration required'
  },
  authenticationWarningSubtitle: {
    id: 'CatalogOpenApi.MappingStepMessages.authenticationWarningSubtitle',
    defaultMessage:
      'The authentication configured for this extension is not available in the OpenAPI document below. After uploading, you will need to re-configure your authentication.'
  },
  authenticationNotice: {
    id: 'CatalogOpenApi.MappingStepMessages.authenticationNotice',
    defaultMessage:
      'The authentication for this extension has been removed and must be re-configured.'
  },
  serversEmptyTitle: {
    id: 'CatalogOpenApi.MappingStepMessages.serversEmptyTitle',
    defaultMessage: 'Servers required'
  },
  serversEmptySubtitle: {
    id: 'CatalogOpenApi.MappingStepMessages.serversEmptySubtitle',
    defaultMessage: 'The OpenAPI document does not contain servers'
  },
  serverWarningTitle: {
    id: 'CatalogOpenApi.MappingStepMessages.serverWarningTitle',
    defaultMessage: 'Server URL re-configuration required'
  },
  serverWarningSubtitle: {
    id: 'CatalogOpenApi.MappingStepMessages.serverWarningSubtitle',
    defaultMessage:
      'The server URL configured for this extension is not available in the OpenAPI document below. After uploading, you will need to re-configure your server URL.'
  },
  serverNotice: {
    id: 'CatalogOpenApi.MappingStepMessages.serverNotice',
    defaultMessage:
      'The server URL for this extension has been removed and must be re-configured.'
  }
});
